const menuData = [
    { name: 'webHome', link: '#welcome-screen' },
    { name: 'webEvent', link: '#about-event' },
    { name: 'webUcinkujici', link: '#performers' },
    { name: 'webGallery', link: '#photo-gallery' },
    { name: 'webVidea', link: '#after-movies' },
    /* { isNotKey: true, name: 'Test swiper', link: '/test_swiper' },
    { isNotKey: true, name: 'gallery UK', link: '/gallery/uk' }, */
]
export default menuData